'use client'

import { Button } from '@brew/ui/button'
import Link from 'next/link'
import { useTranslations } from 'next-intl'
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyTitle,
} from '@/components/ui/empty'
import { buildEmailsPath } from '@/lib/emails/emails-route'

export function SentEmptyState() {
  const t = useTranslations('templates')
  return (
    <Empty className="gap-4 p-8 md:p-8">
      <EmptyHeader className="max-w-md gap-4">
        <EmptyTitle className="text-base">{t('sent.emptyTitle')}</EmptyTitle>
        <EmptyDescription>{t('sent.emptyDescription')}</EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <Button variant="outline" asChild>
          <Link href={buildEmailsPath({ kind: 'grid' })}>
            {t('sent.goToEmails')}
          </Link>
        </Button>
      </EmptyContent>
    </Empty>
  )
}
